var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationFilled = function SvgLocationFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#location_filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03 18.525C5.11 16.143.843 10.368.843 7.125.844 3.19 4.003 0 7.9 0c3.896 0 7.057 3.19 7.057 7.125 0 3.243-4.3 9.018-6.186 11.4a1.104 1.104 0 0 1-1.742 0ZM7.9 9.5c1.298 0 2.352-1.065 2.352-2.375S9.198 4.75 7.9 4.75c-1.297 0-2.352 1.065-2.352 2.375S6.603 9.5 7.9 9.5Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "location_filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.844)",
    d: "M0 0h14.113v19H0z"
  })))));
};
export default SvgLocationFilled;